export { setGlobalAttribute } from './setGlobalAttribute';
